import { CatCampaignRecord } from '@/types';
import { DomainCode } from '@australiangreens/ag-internal-components';
import { logger } from '@/util';
import callBackendApi from './call';

export const getCatCampaignsContaining = async (
  token: string,
  containedString: string,
  domainCode: DomainCode,
  abortSignal?: AbortSignal
) => {
  logger.debug('getCatCampaignsContaining() called', { containedString, domainCode });

  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: `/campaigns/containing/${encodeURIComponent(
      containedString
    )}?domainCode=${domainCode}`,
    abortSignal,
  });
  return data as CatCampaignRecord[];
};

export const getCatCampaignsByIds = async (
  token: string,
  ids: number[],
  domainCode: DomainCode,
  abortSignal?: AbortSignal
): Promise<CatCampaignRecord[]> => {
  logger.debug(`getCatCampaignsByIds() called: ids=${ids}; domainCode=${domainCode}`, {});
  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: `/campaigns?ids=${encodeURIComponent(JSON.stringify(ids))}&domainCode=${domainCode}`,
    abortSignal,
  });

  return data;
};
